import { Component } from '@angular/core';
import { FUNDAMENT_PREFIX } from '@app/fundament/fundament-prefix';
import { AppState } from '@app/app-state';
import { Store, select } from '@ngrx/store';
import { selectShowIntroduction } from '../select-show-introduction';
import { dismissIntroduction } from '../actions/dismiss-introduction';

@Component({
  selector: 'app-introduction-message',
  templateUrl: './introduction-message.component.html',
})
export class IntroductionMessageComponent {
  show$ = this.store.pipe(select(selectShowIntroduction));

  prefix: string = FUNDAMENT_PREFIX;

  constructor(private store: Store<AppState>) {}

  dismiss(): void {
    const dismissedAt = new Date();
    this.store.dispatch(dismissIntroduction({ dismissedAt }));
  }
}
